import type { KeyValue } from '../../net/progress';

/** Seed du « Songe du jour » choisie au hub : la valeur, le jour (`YYYY-MM-DD`) et sa provenance (serveur, ou seed locale de repli). */
export interface DailyChoice { seed: number; day: string; source: 'server' | 'local'; }

/** Seed du « Songe du jour » hors ligne : FNV-1a 32 bits de `jour + 'rogfus'` (entier non signé). Stable pour un jour donné, différente d'un jour à l'autre. */
export function localDailySeed(day: string): number {
  let hash = 0x811c9dc5;
  for (const byte of new TextEncoder().encode(`${day}rogfus`)) {
    hash ^= byte;
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash >>> 0;
}

const cacheKey = (day: string): string => `rogfus.dailySeed.${day}`;

/** Seed serveur du jour mise en cache (`rogfus.dailySeed.<jour>`), `null` si absente ou illisible. */
export function cachedDailySeed(kv: KeyValue, day: string): number | null {
  let raw: string | null;
  try { raw = kv.get(cacheKey(day)); } catch { return null; }
  if (raw === null || !/^[0-9]{1,10}$/.test(raw)) return null;
  const n = Number(raw);
  return n <= 0xffffffff ? n : null;
}

/** Garde la seed serveur du jour (jamais une seed locale de repli) pour la reprendre sans réseau. */
export function cacheDailySeed(kv: KeyValue, day: string, seed: number): void {
  try { kv.set(cacheKey(day), String(seed >>> 0)); } catch { /* stockage indisponible : la seed sera redemandée */ }
}
